module.exports = __webpack_public_path__ + "static/media/edu_ilastration1.294d5176.png";